<template>
<Form ref="form" :label-width="labelWidth" :label-position="labelWidth > 300 ? 'left' : 'right'" justify="center" align="top">
  <Row>
    <Col :span="Number(item.var.width)" v-for="item in items" :key="item.var.id">
            <text-element v-if="item.var.type === 'text'" :model="item.val" :inline="inline"></text-element>
            <long-element v-if="item.var.type === 'long'" :model="item.val" :inline="inline"></long-element>
            <int-element v-if="item.var.type === 'int'" :model="item.val" :inline="inline"></int-element>
            <float-element v-if="item.var.type === 'float'" :model="item.val" :inline="inline"></float-element>
            <date-element v-if="item.var.type === 'date'" :model="item.val" :inline="inline"></date-element>
            <time-element v-if="item.var.type === 'time'" :model="item.val" :inline="inline"></time-element>
            <datetime-element v-if="item.var.type === 'datetime'" :model="item.val" :inline="inline"></datetime-element>
            <radio-element v-if="item.var.type === 'radio'" :model="item.val" :inline="inline"></radio-element>
            <checkbox-element v-if="item.var.type === 'checkbox'" :model="item.val" :inline="inline"></checkbox-element>
    </Col>
  </Row>
  <FormItem>
    <Button type="primary" @click="handleSubmit('form')" long>保存</Button>
  </FormItem>
  <Spin size="large" fix v-if="spinShow"></Spin>
</Form>
</template>

<script>
import { EditVariable, EditForm } from '@/api/subject'
import TextElement from './elements/TextElement'
import LongElement from './elements/LongElement'
import IntElement from './elements/IntElement'
import FloatElement from './elements/FloatElement'
import DateElement from './elements/DateElement'
import TimeElement from './elements/TimeElement'
import DateTimeElement from './elements/DateTimeElement'
import RadioElement from './elements/RadioElement'
import CheckboxElement from './elements/CheckboxElement'

export default {
  name: 'create-domain',
  data: () => ({
    inline: 1,
    spinShow: false,
    width: 0
  }),
  computed: {
    labelWidth () {
      let width = 160
      for (let i = 0; i < this.items.length; i++) {
        const item = this.items[i]
        const len = item.var.label.length
        width = width < len * 14 ? len * 14 : width
      }
      return width > 720 ? 720 : width
    }
  },
  components: {
    'text-element': TextElement,
    'long-element': LongElement,
    'int-element': IntElement,
    'float-element': FloatElement,
    'date-element': DateElement,
    'time-element': TimeElement,
    'datetime-element': DateTimeElement,
    'radio-element': RadioElement,
    'checkbox-element': CheckboxElement
  },
  // watch: {
  //   'seq': function () {
  //     console.log(this.seq)
  //     console.log(this.items)
  //     this.newItems = this.items
  //   }
  // },
  props: ['items', 'model', 'seq'],
  methods: {
    getWidth: function (width) {
      this.width = this.width + width
      return this.width
    },
    editVal: function (variable, val) {
      const data = {
        usubjid: this.model.usubjid,
        domainid: variable.domainid,
        studyid: this.$route.params.id,
        varid: variable.id,
        visitid: this.model.visitid,
        batch: this.model.batch,
        val: val,
        seq: this.seq ? this.seq : null
      }
      EditVariable(data).then(async res => {})
    },
    handleSubmit: function (form) {
      this.spinShow = true
      this.buildForm()
    },
    buildForm: function () {
      const data = {
        usubjid: this.model.usubjid,
        studyid: this.$route.params.id,
        domainid: this.model.domainid,
        visitid: this.model.visitid,
        batch: this.model.batch,
        seq: this.seq ? this.seq : null
      }
      const vars = []
      for (const i in this.items) {
        const item = this.items[i]
        vars.push({
          'varid': item.val.varid,
          'val': item.val.val
        })
      }
      data['items'] = vars
      EditForm(this.$route.params.stateid, data).then(async res => {
        this.$Message.success('保存成功')
        this.spinShow = false
      })
    }
  }
}
</script>

<style>
.edit-var-instructions {
  font-size: .8em;
  color: #8e8e8e;
  text-align: right;
}
</style>
